import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const AttendanceTracking = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Devam Takibi
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Devam takibi burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default AttendanceTracking;
